import { FC } from "react";

interface PasswordEyeIconSVGProps {
    isPasswordVisible: boolean;
    setPasswordVisible(value: boolean): void;
    className?: string;
}

const PasswordEyeIconSVG: FC<PasswordEyeIconSVGProps> = (props) => {
    return (
        <div>
            {props.isPasswordVisible ? (
                <svg
                    className={props.className}
                    onClick={() => props.setPasswordVisible(!props.isPasswordVisible)}
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M11.5266 11.5266C11.1827 11.847 10.9069 12.2334 10.7156 12.6628C10.5243 13.0921 10.4214 13.5556 10.4131 14.0255C10.4049 14.4955 10.4913 14.9623 10.6673 15.3981C10.8434 15.8339 11.1054 16.2298 11.4377 16.5621C11.7701 16.8945 12.166 17.1565 12.6018 17.3325C13.0376 17.5085 13.5044 17.595 13.9743 17.5867C14.4443 17.5784 14.9078 17.4756 15.3371 17.2843C15.7664 17.093 16.1528 16.8172 16.4732 16.4733"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12.5186 5.92659C13.0101 5.86535 13.5049 5.83418 14.0002 5.83325C22.1669 5.83325 25.6669 13.9999 25.6669 13.9999C25.1453 15.1166 24.4911 16.1663 23.7186 17.1266"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M7.71183 7.71167C5.39162 9.29206 3.53501 11.4628 2.3335 14C2.3335 14 5.8335 22.1667 14.0002 22.1667C16.2354 22.1727 18.4227 21.5193 20.2885 20.2883"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M2.3335 2.33325L25.6668 25.6666"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            ) : (
                <svg
                    className={props.className}
                    onClick={() => props.setPasswordVisible(!props.isPasswordVisible)}
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2.3335 14C2.3335 14 5.8335 5.83333 14.0002 5.83333C22.1668 5.83333 25.6668 14 25.6668 14C25.6668 14 22.1668 22.1667 14.0002 22.1667C5.8335 22.1667 2.3335 14 2.3335 14Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M14 17.5C15.933 17.5 17.5 15.933 17.5 14C17.5 12.067 15.933 10.5 14 10.5C12.067 10.5 10.5 12.067 10.5 14C10.5 15.933 12.067 17.5 14 17.5Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )}
        </div>
    );
};

export default PasswordEyeIconSVG;
